import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HomeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { getBitacoraSincronizacion } from 'actions/bitacora.actions';
import { TablaBitacora } from './components/TablaBitacora';
import { BuscadorBitacora } from './components/BuscadorBitacora';
import './BitacoraSincronizacion.scss';

export function BitacoraSincronizacion() {
  const [mainFilters, setMainFilters] = useState({});
  const [bitacoraData, setBitacoraData] = useState([]);
  const [bitacoraDataAux, setBitacoraDataAux] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [paginationParams, setPaginationParams] = useState({ page: 1, pageSize: 10 });
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [paginationCurrent, setPaginationCurrent] = useState(null);
  const [paginationsPageSize, setPaginationsPageSize] = useState(null);
  const [paramReports, setParamReports] = useState(null);
  const dispatch = useDispatch();

  const getBusquedaBitacora = async (params) => {
    setLoadingTable(true);
    try {
      if (params && params.idProcesoElectoral !== undefined) {
        setMainFilters(params);
        const { success, response } = await dispatch(
          getBitacoraSincronizacion({
            ...params,
            pagina: paginationParams.page || 1,
            cantidad: paginationParams.pageSize || 10
          })
        );
        if (success) {
          setBitacoraData(response.bitacora || []);
          setTotalRegistros(response.total || 0);
          setParamReports(params);
        } else {
          setBitacoraData([]);
          setTotalRegistros(0);
        }
      } else {
        setBitacoraData([]);
        setTotalRegistros(0);
      }
    } catch (error) {
      console.log('Error', error);
    } finally {
      setLoadingTable(false);
    }
  };

  useEffect(() => {
    if (mainFilters && mainFilters.idProcesoElectoral !== undefined) {
      getBusquedaBitacora(mainFilters);
    }
  }, [paginationParams]);

  const handlePaginationChange = (page, pageSize) => {
    setPaginationParams({ ...paginationParams, page, pageSize });
  };

  useEffect(() => {
    const bitacoraReportData = async () => {
      try {
        if (paramReports && paramReports.idProcesoElectoral !== undefined) {
          setBitacoraDataAux([]);
          const { success, response } = await dispatch(
            getBitacoraSincronizacion({
              ...paramReports,
              pagina: paginationCurrent || 1,
              cantidad: paginationsPageSize || 10
            })
          );
          if (success) {
            setBitacoraDataAux(response.bitacora || []);
          } else {
            setBitacoraDataAux([]);
          }
        }
      } catch (error) {
        console.log('Error', error);
      }
    };
    bitacoraReportData();
  }, [paginationCurrent, paginationsPageSize]);

  useEffect(() => {
    setBitacoraData(bitacoraDataAux);
  }, [bitacoraDataAux]);

  return (
    <div className="bitacora-sincronizacion">
      <div>
        <HomeOutlined style={{ fontSize: '13px' }} /> |{' '}
        <span style={{ color: '#AAAAAA', fontSize: '13px' }}>Reportes</span> |{' '}
        <span style={{ color: '#c12b7d', fontSize: '13px' }}>Bitácora de sincronización</span>
      </div>
      <h1 className="title-label">Bitácora de sincronización</h1>
      <div className="message-label">
        <span>
          <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
          Captura la información solicitada para realizar la búsqueda.
        </span>
        <span style={{ color: 'red' }}> *Campos obligatorios.</span>
      </div>
      <br />
      <BuscadorBitacora onSearch={getBusquedaBitacora} />
      <TablaBitacora
        bitacoraData={bitacoraData}
        loadingTable={loadingTable}
        onChangePagination={handlePaginationChange}
        paginationBusqueda={paginationParams}
        totalRegistros={totalRegistros}
        paginationCurrent={setPaginationCurrent}
        paginationsPageSize={setPaginationsPageSize}
        filtrosReporte={paramReports}
      />
    </div>
  );
}

export default BitacoraSincronizacion;
